var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"stream-player"},[_c('video',{ref:"video",staticClass:"video-js",attrs:{"controls":"","muted":"","preload":"auto"},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }